import { render } from "./SettingsListElement.vue?vue&type=template&id=84f9ff24&ts=true"
import script from "./SettingsListElement.vue?vue&type=script&lang=ts"
export * from "./SettingsListElement.vue?vue&type=script&lang=ts"

import "./SettingsListElement.vue?vue&type=style&index=0&id=84f9ff24&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem,QBtn,QItem});
